const registros = {
  infoAce: [
    {
      slug: "reportes-registros-acelerometricos",
      origin: "acerca-de",
      title: "Reportes y registros acelerométricos",
      data: [
        {
          title: ` Decreto Supremo N° 069-2011-PCM (27. Jul.2011)
 Se crea el Portal  de la Información de Datos  Espaciales del Perú” GEOIDEP) como ventanilla única de Internet que  permite el acceso a todos los datos, información y servicios geográficos que brindan los organismos públicos y privados del Perú. En este  Portal, todas las entidades deben reportar los metadatos de los  productos que  generen. Se aplica a todas las entidades de la Administración Pública que integran el Sistema Nacional de Informática  que  generen y utilicen información de mapas cartográficos básicos y temáticos. Cabe resaltar que  se establece la obligatoriedad de las entidades de designar al Jefe  de la unidad informática o quien haga sus veces como responsable encargado de coordinar la publicación y catalogación de los datos, servicios  y aplicaciones geoespaciales de la información territorial de la entidad que  representa, quien se encargará además de actualizar las publicaciones que  se generen en forma permanente.`,
          content: () => [
            <p>Decreto Supremo N° 069-2011-PCM (27. Jul.2011)</p>,
            <p>
              Se crea el Portal de la Información de Datos Espaciales del Perú”
            </p>
          ],
          link:
            "https://www.geoidep.gob.pe/marco-normativo-institucional-de-la-idep/normas-basicas/decretosupremon069-2011-pcm"
        }
      ]
    }
  ]
};
function getRegistros(program) {
  return registros[program] || "cts";
}
export { getRegistros };
